import React from 'react'
import PropTypes from 'prop-types'
import { errorLogger } from '../../utils/loggerUtils'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // log the error to an error UI logger
    const exceptionMsg =
      'Payee Management - Internal app error caught by error boundary.'
    errorLogger({
      exceptionMsg,
      exceptionCode: 600,
      stack: error.stack ? error.stack : '',
      eventAttributes: {
        message: error.message ? error.message : 'No Message to display',
        componentTrace: errorInfo.componentStack ? errorInfo.componentStack : ''
      }
    })
  }

  render() {
    const { hasError } = this.state
    if (hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>
      // Below changes has to implement to redirect to common error page.
      // <ErrorMessageContanier intl={intl} resetErrorState={this.resetErrorState} isRenderedFromErrorBoundary />
    }
    const { children } = this.props
    return children
  }
}
ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
}
